(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("PauseLearnerEmailsNoteCtrl", ["authService", "pauseLearnerEmailService", pauseLearnerEmailsNoteCtrl]);
    function pauseLearnerEmailsNoteCtrl(authService, pauseLearnerEmailService) {
        var vm = this;
        vm.isSuperAdmin = authService.isSuperAdmin();
        pauseLearnerEmailService.getData().then(function (data) {
            vm.model = data;
        });
    }
}());
